var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('div',{staticStyle:{"height":"20px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }